// extracted by mini-css-extract-plugin
export default {"container":"SectionBucarMVS_container__4v+LD"};